import MUIFormControlLabel from '@mui/material/FormControlLabel';
import MUICheckbox from '@mui/material/Checkbox';
import InfoItem from '../InfoItem';
import ReportSetting from "../ReportSetting";
import MainContext from "../../Context/MainContext/MainContext";

export default class ReportSettingOnlyActiveAccounts extends ReportSetting {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders only active accounts checkbox for selecting only active accounts.
     */
    renderOnlyActiveAccountsCheckbox() {
        return (
            <MUIFormControlLabel
                control={
                    <MUICheckbox
                        size="small"
                        checked={this.state.settings.activeAccounts === true}
                        onChange={(e) => this.handleSettingChange("activeAccounts", e.target.checked)}
                    />
                }
                label="Only Active Accounts"
            />
        );
    }

    renderContent() {
        return (
            <>
                {this.renderOnlyActiveAccountsCheckbox()}
            </>
        );
    }

    renderReadOnly() {
        return <InfoItem label="Only Active Accounts" value={this.state.settings.activeAccounts ? "Yes" : "No"} />;
    }
}
